module.exports = {
          srcSet: __webpack_public_path__ + "fdaffa83.jpg"+" 330w",
          images:[ {path: __webpack_public_path__ + "fdaffa83.jpg",width: 330,height: 200}],
          src: __webpack_public_path__ + "fdaffa83.jpg",
          toString:function(){return __webpack_public_path__ + "fdaffa83.jpg"},
          
          width: 330,
          height: 200
        }